import React, { useState } from "react";
import { COUNTRIES } from "../../data/kdm";
import Reveal from "../Reveal";

export default function Footprint() {
  const [active, setActive] = useState("LK");
  const current = COUNTRIES.find((c) => c.code === active) || COUNTRIES[0];

  return (
    <section
      id="footprint"
      data-testid="footprint-section"
      className="bg-white py-28 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="overline">Our Global Footprint</p>
          <h2
            data-testid="footprint-heading"
            className="font-serif font-medium text-4xl lg:text-5xl mt-6 leading-[1.05] tracking-tight"
          >
            Five countries.
            <br />
            <span className="italic text-gold">One trusted name.</span>
          </h2>

          <Reveal delay={120}>
            <p className="text-base text-[--kdm-ink-soft] mt-8 leading-relaxed max-w-md">
              From our HQ in Sri Lanka to operations in Italy, Spain, Bangladesh and the
              United States — KDM Group connects continents through commerce, culture and
              capital.
            </p>
          </Reveal>

          {/* Country list */}
          <div className="mt-12 divide-y divide-[--kdm-line] border-t border-[--kdm-line]">
            {COUNTRIES.map((c) => (
              <button
                key={c.code}
                data-testid={`country-${c.code.toLowerCase()}`}
                onClick={() => setActive(c.code)}
                onMouseEnter={() => setActive(c.code)}
                className={`group w-full flex items-center justify-between py-5 text-left transition-colors duration-300 ${
                  active === c.code ? "text-[--kdm-ink]" : "text-[--kdm-ink-soft]"
                }`}
              >
                <div className="flex items-center gap-5">
                  <span
                    className={`text-xs tracking-[0.3em] font-semibold transition-colors ${
                      active === c.code ? "text-gold" : "text-[--kdm-ink-soft]"
                    }`}
                  >
                    {c.code}
                  </span>
                  <span className="font-serif text-2xl lg:text-3xl tracking-tight">
                    {c.name}
                  </span>
                </div>
                <span
                  className={`hidden md:block text-xs tracking-[0.18em] uppercase max-w-[260px] text-right ${
                    active === c.code ? "text-[--kdm-ink]" : "text-[--kdm-ink-soft]"
                  }`}
                >
                  {c.role}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Map / Active country panel */}
        <div className="lg:col-span-7">
          <div className="card-soft h-full p-10 lg:p-14 relative overflow-hidden">
            {/* Decorative dotted world */}
            <svg
              className="absolute inset-0 w-full h-full opacity-[0.07]"
              viewBox="0 0 800 400"
              fill="none"
              aria-hidden
            >
              {Array.from({ length: 60 }).map((_, r) =>
                Array.from({ length: 120 }).map((_, c) => {
                  const cx = c * 7 + 4;
                  const cy = r * 7 + 4;
                  // Random sparse dot pattern
                  if ((r * 7 + c) % 3 === 0 && Math.sin(r * c) > 0.2) {
                    return <circle key={`${r}-${c}`} cx={cx} cy={cy} r="1.1" fill="#1A1A1A" />;
                  }
                  return null;
                })
              )}
            </svg>

            <div className="relative">
              <p className="overline">Currently viewing</p>
              <h3
                data-testid="footprint-active-name"
                className="font-serif text-5xl lg:text-7xl mt-4 leading-none tracking-tight"
              >
                {current.name}
              </h3>
              <span className="kdm-divider mt-7" />
              <p className="text-base text-[--kdm-ink-soft] mt-7 max-w-md leading-relaxed">
                {current.role}
              </p>

              <div className="grid grid-cols-3 gap-6 mt-14 pt-8 border-t border-[--kdm-line]">
                <div>
                  <p className="overline">Region</p>
                  <p className="font-serif text-xl mt-2">
                    {current.code === "LK" || current.code === "BD"
                      ? "South Asia"
                      : current.code === "IT" || current.code === "ES"
                      ? "Europe"
                      : "North America"}
                  </p>
                </div>
                <div>
                  <p className="overline">Operating since</p>
                  <p className="font-serif text-xl mt-2">2010</p>
                </div>
                <div>
                  <p className="overline">Status</p>
                  <p className="font-serif text-xl mt-2 text-gold">Active</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
